"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportCompositePhotoOnly = void 0;
var tslib_1 = require("tslib");
var core_shared_1 = require("@ikegps/core-shared");
var i18n_1 = require("../../../i18n");
var store_1 = require("../../../store");
var ImageWithTitle_1 = require("../components/ImageWithTitle");
var TitleBar_1 = require("../components/TitleBar");
var ReportHelpers_1 = require("../ReportHelpers");
var ReportBase_1 = require("./ReportBase");
var ReportCompositePhotoOnly = /** @class */ (function (_super) {
    tslib_1.__extends(ReportCompositePhotoOnly, _super);
    function ReportCompositePhotoOnly(poles) {
        return _super.call(this, poles) || this;
    }
    ReportCompositePhotoOnly.prototype.buildPDF = function () {
        var _this = this;
        this.poles.forEach(function (pole, i) {
            var job = store_1.AppStore.Tag.get(pole.jobId);
            pole.forEachField(function (field) {
                // Truesize images
                if (field instanceof core_shared_1.CollectionModelFieldTrueSize) {
                    var captures = field.getCaptures();
                    captures.forEach(function (capture) {
                        if (!(0, ReportHelpers_1.isCaptureHidden)(pole, capture.objectId)) {
                            if ((0, ReportHelpers_1.hasUserMeasurement)(pole, capture.objectId)) {
                                var imageReferenceString = (0, ReportHelpers_1.captureReferenceString)(pole, capture);
                                _this.images[imageReferenceString] = (0, ReportHelpers_1.compositeURL)(pole, capture);
                                // Title
                                _this.nodes.push(new TitleBar_1.TitleBar(pole.title || (0, i18n_1.Translate)(i18n_1.T.COLLECTION_MISSING_TITLE), job.name, i + 1, _this.poles.length));
                                // Image
                                _this.nodes.push(new ImageWithTitle_1.ImageWithTitle(field.schema.displayName, { reference: imageReferenceString }));
                            }
                        }
                    });
                }
            });
        });
    };
    return ReportCompositePhotoOnly;
}(ReportBase_1.ReportBase));
exports.ReportCompositePhotoOnly = ReportCompositePhotoOnly;
//# sourceMappingURL=ReportCompositePhotoOnly.js.map